angular.module('app').controller('NavigationBillingCtrl',
    ['$scope', 'LocalStorageRepository', '$stateParams',
        function ($scope, LocalStorageRepository) {
            'use strict';

            var fullName = LocalStorageRepository.getUserFullName(),
                userID = LocalStorageRepository.getUserID();

            $scope.CurrentUser = {
                FullName: fullName,
                Id: userID
            };

        }]);